const styles = {
  container: {
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    marginY: 6,
  },
  text: {
    marginY: 2,
  },
  mainButtom: {
    paddingX: 10,
    width: '100%',
    maxWidth: '400px',
  },
  field: {
    mb: 1,
  },
  titleh2: {
    maxWidth: '416px',
    textAlign: 'center',
  },

}

export default styles
